module.exports = __webpack_public_path__ + "static/media/icon_1.bb3e1794.svg";